<template>
  <v-dialog
    max-width="400"
    :value="true"
    @click:outside="$emit('cancel')"
  >
    <v-card>
      <v-card-title>
        <h2>Assign {{ name }} to Organization</h2>
      </v-card-title>

      <v-card-text>
        <v-select
          v-model="organizationId"
          :items="organizations"
          item-text="name" item-value="id"
          solo
        ></v-select>
      </v-card-text>

      <v-card-actions>
        <button
          class="default-btn blue"
          :disabled="!organizationId"
          @click="$emit('submit', organizationId)"
        >Assign to Organizations</button>

        <button class="default-btn text" @click="$emit('cancel')">Cancel</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogAssignToOrganization',
  props: {
    name: String,
    organizations: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    organizationId: '',
  }),
}
</script>

<style lang="scss" scoped></style>
